module.exports = __webpack_public_path__ + "static/media/hedgehog.9b582b35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/hedgehog.svg
// module id = 619
// module chunks = 6